
export const TransformationTemplateId = {
  INPUT: 'inputCRS',
  OUTPUT: 'outputCRS',
}
